(() => {
  // app/scripts/components/coveo/CoveoRecentQueries.js
  var RECENT_QUERIES_KEY = "coveo-recent-queries";
  var { buildRecentQueriesList } = coveoheadless;
  var CoveoRecentQueries = class extends HTMLElement {
    constructor() {
      super();
      this.recentQueriesContainer = this.querySelector(".js-recent-queries-list");
      const recentQueries = JSON.parse(localStorage.getItem(RECENT_QUERIES_KEY) || "[]");
      this.recentQueriesStorage = new Set(recentQueries.map((query) => query.trim()));
      this.recentQueryTemplate = this.recentQueriesContainer.innerHTML;
      this.recentQueriesContainer.innerHTML = "";
      this.callbacks = [];
      this.listenItemClick();
    }
    get count() {
      return this.recentQueriesStorage.size;
    }
    connectedCallback() {
      this.checkAndSaveStorage();
      this.renderRecentQueries();
    }
    renderRecentQueries() {
      this.recentQueriesContainer.innerHTML = Array.from(this.recentQueriesStorage).reverse().map((query, index) => this.recentQueryTemplate.replaceAll("[label]", query).replaceAll("[index]", index)).join("");
    }
    checkAndSaveStorage() {
      if (this.recentQueriesStorage.size > 10) {
        this.recentQueriesStorage = new Set(Array.from(this.recentQueriesStorage).slice(-10));
      }
      localStorage.setItem(RECENT_QUERIES_KEY, JSON.stringify(Array.from(this.recentQueriesStorage)));
    }
    saveQuery(query) {
      if (!query)
        return;
      const queryTrimmed = query.trim();
      this.recentQueriesStorage.delete(queryTrimmed);
      this.recentQueriesStorage.add(queryTrimmed);
      this.checkAndSaveStorage();
      this.renderRecentQueries();
    }
    buildRecentQueriesList(...args) {
      this.controller = buildRecentQueriesList(...args);
      this.controller.subscribe(() => {
      });
      return this.controller;
    }
    onClick(callback) {
      this.callbacks.push(callback);
    }
    listenItemClick() {
      this.recentQueriesContainer.addEventListener("click", (event) => {
        event.stopPropagation();
        const clickedQuery = event.target.textContent.trim();
        this.saveQuery(clickedQuery);
        this.callbacks.forEach((callback) => callback(clickedQuery));
      });
    }
  };

  // app/scripts/coveo-search-analytics.js
  var ANALYTICS_EVENT_TYPE = "search";
  var CoveoSearchAnalytics = class {
    constructor(engine) {
      this.engine = engine;
    }
    get _config() {
      const { organizationId, accessToken, analytics } = this.engine.configuration;
      return {
        organizationId,
        accessToken,
        trackingId: analytics.trackingId
      };
    }
    get _endpoint() {
      const { organizationId } = this._config;
      return `https://${organizationId}.analytics.org.coveo.com/rest/ua/v15/analytics/${ANALYTICS_EVENT_TYPE}`;
    }
    get _searchState() {
      return this.engine.store.getState().commerceSearch || {};
    }
    _getClientId() {
      try {
        return this.engine.relay.getMeta("").clientId;
      } catch (error) {
        console.warn(`[CoveoSearchAnalytics] Failed to get clientId:`, error);
        return void 0;
      }
    }
    _getFacetState(pendingChange = null) {
      const { facets } = this._searchState;
      if (!Array.isArray(facets))
        return [];
      return facets.flatMap(
        (facet) => facet.values.reduce((acc, v, index) => {
          let isSelected = v.state === "selected";
          if (pendingChange && pendingChange.facetId === facet.facetId && pendingChange.value === v.value) {
            isSelected = pendingChange.action === "select";
          }
          if (isSelected) {
            acc.push({
              field: facet.facetId,
              id: facet.facetId,
              title: facet.displayName || facet.facetId,
              facetType: "specific",
              value: v.value,
              valuePosition: index + 1,
              displayValue: v.value,
              state: "selected"
            });
          }
          return acc;
        }, [])
      );
    }
    _buildPayload(actionCause, customData = {}, { pendingChange = null, responseId: responseIdOverride } = {}) {
      const { trackingId } = this._config;
      const state = this.engine.store.getState();
      const { responseId, queryExecuted } = state.commerceSearch || {};
      const language = state.commerceContext?.language || document.documentElement.lang || "en";
      return {
        actionCause,
        searchQueryUid: responseIdOverride || responseId,
        queryText: queryExecuted || "",
        language,
        originLevel1: trackingId,
        originLevel2: "default",
        originLevel3: window.location.href,
        clientId: this._getClientId(),
        anonymous: false,
        responseTime: 0,
        customData,
        facetState: this._getFacetState(pendingChange ?? null)
      };
    }
    async logSearchEvent(actionCause, customData = {}, options = {}) {
      const { accessToken } = this._config;
      if (!accessToken)
        return;
      const payload = this._buildPayload(actionCause, customData, options);
      try {
        const response = await fetch(this._endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          console.warn(`[CoveoSearchAnalytics] ${actionCause} failed:`, response.status);
        }
      } catch (error) {
        console.warn(`[CoveoSearchAnalytics] ${actionCause} error:`, error);
      }
    }
    logInterfaceLoad() {
      return this.logSearchEvent("interfaceLoad");
    }
    logSearchboxSubmit() {
      return this.logSearchEvent("searchboxSubmit");
    }
    logSearchFromLink() {
      return this.logSearchEvent("searchFromLink");
    }
    logOmniboxAnalytics(metadata = {}) {
      return this.logSearchEvent("omniboxAnalytics", metadata);
    }
    logRecommendationInterfaceLoad(responseId) {
      return this.logSearchEvent("recommendationInterfaceLoad", {}, { responseId });
    }
    logFacetSelect(facetId, facetValue) {
      return this.logSearchEvent("facetSelect", {
        facetId,
        facetValue,
        facetField: facetId
      }, { pendingChange: { facetId, value: facetValue, action: "select" } });
    }
    logFacetDeselect(facetId, facetValue) {
      return this.logSearchEvent("facetDeselect", {
        facetId,
        facetValue,
        facetField: facetId
      }, { pendingChange: { facetId, value: facetValue, action: "deselect" } });
    }
    logFacetClearAll() {
      return this.logSearchEvent("facetClearAll");
    }
  };
  var coveo_search_analytics_default = CoveoSearchAnalytics;

  // app/scripts/utils/fetchSortedProductCards.js
  async function fetchSortedProductCards(products) {
    const productIDs = products.map(({ ec_item_group_id }) => ec_item_group_id);
    const query = productIDs.map((id) => `id:${id}`).join(" OR ");
    const response = await fetch(`${theme.routes.searchUrl}?view=coveo-search-form&type=product&q=${query}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product cards: ${response.status} ${response.statusText}`);
    }
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const items = [...doc.querySelectorAll("[data-product-id]")];
    const itemsById = new Map(items.map((item) => [item.dataset.productId, item]));
    const sorted = productIDs.map((id) => itemsById.get(id)).filter(Boolean);
    return sorted.map((el) => el.outerHTML).join("");
  }

  // app/scripts/coveo-search-form.js
  var { delay } = theme;
  var {
    buildStandaloneSearchBox,
    loadQuerySuggestActions,
    loadQuerySetActions,
    buildSearch,
    loadSearchActions,
    loadQueryActions
  } = window.coveoheadless;
  var CoveoSearchForm = class extends HTMLElement {
    constructor() {
      super();
      this.firstRender = true;
      this.input = this.querySelector("input");
      this.suggestionsContainer = this.querySelector(".js-suggestions-list");
      this.productsContainer = this.querySelector(".js-products-container");
      this.brandsContainer = this.querySelector(".js-brands-list");
      this.recentQueries = this.querySelector("coveo-recent-queries");
      this.searchPage = document.querySelector("coveo-search-page");
      this.clearButton = this.querySelector(".js-clear-btn");
    }
    async connectedCallback() {
      await customElements.whenDefined("coveo-recent-queries");
      await this.initControllers();
      this.initInputEvents();
      this.initClearButton();
      this.initCloseEvents();
      this.initViewAllButton();
    }
    async initControllers() {
      const searchToken = await CoveoUtils.getSearchToken();
      const redirectionUrl = `${window.location.origin}${theme.routes.searchUrl}`;
      if (!searchToken) {
        console.error("Failed to fetch search token");
        return;
      }
      const engine = this.engine = window.configureHeadless(searchToken);
      this.analytics = new coveo_search_analytics_default(this.engine);
      this.executeSearch = loadSearchActions(this.engine).executeSearch;
      this.queryActions = loadQueryActions(this.engine);
      this.querySetActions = loadQuerySetActions(this.engine);
      this.querySuggestActions = loadQuerySuggestActions(this.engine);
      if (this.recentQueries) {
        this.initRecentQueriesList(engine);
      }
      this.searchBox = buildStandaloneSearchBox(engine, {
        options: {
          numberOfSuggestions: 5,
          highlightOptions: {
            correctionDelimiters: {
              open: "<b class='font-bold'>",
              close: "</b>"
            },
            exactMatchDelimiters: {
              open: "<b class='font-bold'>",
              close: "</b>"
            }
          },
          enableQuerySyntax: false,
          redirectionUrl
        }
      });
      this.searchBox.subscribe(() => {
        const { redirectTo } = this.searchBox.state;
        if (redirectTo && this._awaitingRedirect && redirectTo !== this._lastHandledRedirectTo) {
          this._lastHandledRedirectTo = redirectTo;
          this._awaitingRedirect = false;
          this.setState("close");
          const query = this._pendingSearchQuery || this.input.value.trim();
          this._pendingSearchQuery = null;
          if (this.searchPage && redirectTo === redirectionUrl) {
            this.searchPage.search(query);
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
          }
          const url = new URL(redirectTo, window.location.origin);
          if (redirectTo === redirectionUrl && !url.searchParams.has("q") && query) {
            url.searchParams.set("q", query);
          }
          window.location.href = url.toString();
          return;
        }
        if (this.searchBox.state.isLoadingSuggestions) {
          this.setState("loading");
          return;
        }
        if (this.isLoading() && this.searchPage) {
          this.renderLayout();
        }
      });
      this.search = buildSearch(engine);
      this.search.subscribe(() => {
        if (this.search.state.isLoading) {
          return;
        }
        this.renderLayout();
      });
      this.pagination = this.search.pagination({ options: { pageSize: 4 } });
      this.initSuggestionsEvents();
      this.initBrandsEvent();
    }
    initBrandsEvent() {
      this.setupQuerySelection(this.brandsContainer, (query) => {
        this.submitSearch(query);
      });
    }
    initSuggestionsEvents() {
      this.setupQuerySelection(this.suggestionsContainer, (query, index) => {
        this.analytics?.logOmniboxAnalytics({
          partialQueries: this.input.value,
          suggestionRanking: index,
          partialQuery: this.input.value
        });
        this.submitSearch(query, { skipAnalytics: true });
      });
    }
    setupQuerySelection(container, onSelect) {
      if (!container)
        return;
      container.addEventListener("click", (event) => {
        event.preventDefault();
        const query = this.getQueryFromClickEvent(event);
        if (!query)
          return;
        const li = event.target.closest("li");
        const index = li ? [...container.children].indexOf(li) : 0;
        this.input.value = query;
        onSelect(query, index);
      });
    }
    getQueryFromClickEvent(event) {
      const button = event.target.closest("button");
      return button ? button.textContent.trim() : "";
    }
    initInputEvents() {
      this.input.addEventListener("focus", () => {
        const flag = ["is-loading", "is-results"].some((a) => this.classList.contains(a));
        this.classList.add("is-open");
        if (this.recentQueries.count && !flag) {
          this.classList.add("is-recent");
        }
      });
      this.input.addEventListener(
        "input",
        debounce(() => {
          const value = this.input.value.trim();
          if (value) {
            this.submit(value);
          } else {
            this.setState("show-recent");
            this.classList.remove("is-typing");
          }
        }, 500)
      );
      this.input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          if (event.isComposing)
            return;
          event.preventDefault();
          const query = this.input.value.trim();
          if (!query)
            return;
          this.submitSearch(query);
        }
      });
    }
    initClearButton() {
      if (!this.clearButton)
        return;
      this.clearButton.addEventListener("click", () => {
        this.input.value = "";
        this.classList.remove("is-typing", "is-results", "is-products-show", "is-empty");
        if (this.recentQueries?.count) {
          this.setState("show-recent");
        } else {
          this.setState("close");
        }
        this.input.focus();
      });
    }
    isLoading() {
      return this.classList.contains("is-loading");
    }
    initRecentQueriesList() {
      this.recentQueries.buildRecentQueriesList(this.engine, { options: { maxLength: 10 } });
      this.recentQueries.onClick((query) => {
        this.input.value = query;
        this.submit(query);
      });
    }
    submitSearch(query, { skipAnalytics = false } = {}) {
      const q = query.trim();
      if (!q)
        return;
      this.recentQueries?.saveQuery(q);
      if (!skipAnalytics)
        this.analytics?.logSearchboxSubmit();
      if (this.searchPage) {
        this.setState("close");
        this.searchPage.search(q);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      sessionStorage.setItem("coveo_searchbox_submit", "1");
      this._pendingSearchQuery = q;
      this._awaitingRedirect = true;
      if (this.searchBox) {
        this.searchBox.updateText(q);
        this.searchBox.submit();
      }
    }
    async submit(query) {
      const {
        querySetActions: { updateQuerySetQuery },
        querySuggestActions: { fetchQuerySuggestions },
        queryActions: { updateQuery }
      } = this;
      const queryTrimmed = query.trim();
      const { searchBoxId } = this.searchBox.state;
      this.recentQueries.saveQuery(queryTrimmed);
      this.classList.add("is-typing");
      this.engine.dispatch(updateQuerySetQuery({ query: queryTrimmed, id: searchBoxId }));
      this.engine.dispatch(fetchQuerySuggestions({ id: searchBoxId }));
      this.engine.dispatch(updateQuery({ query: queryTrimmed }));
      this.engine.dispatch(this.executeSearch());
    }
    async renderLayout() {
      this.updateViewAllButton();
      this.renderSuggestions();
      await this.renderProducts();
      await this.renderBrands();
      this.classList.toggle("is-suggestions-show", this.isShowSuggestions());
      this.checkEmpty();
    }
    isShowSuggestions() {
      const brandCount = this.search.state.facets.find((facet) => facet.facetId === "ec_brand")?.values?.length || 0;
      const suggestionCount = this.searchBox.state.suggestions.length;
      return suggestionCount + brandCount > 0;
    }
    renderBrands() {
      if (!this.brandsContainer)
        return;
      const facetBrands = this.search.state.facets.find((facet) => facet.facetId === "ec_brand");
      const brands = facetBrands?.values?.map((brand) => {
        const regex = new RegExp(`(${this.search.state.queryExecuted})`, "gi");
        return {
          ...brand,
          value: brand.value.replace(regex, "<b class='font-bold'>$1</b>"),
          count: (brand.value.match(regex) || []).length
        };
      }).sort((a, b) => b.count - a.count) || [];
      this.brandsContainer.innerHTML = brands.slice(0, 3).map((brand) => {
        return `<li class="hover:bg-light-neutral-20 active:bg-dark-neutral-20">
                  <button class="block px-4 py-3 lg:py-2 text-left w-full">${brand.value}</button>
                </li>`;
      }).join("");
      this.brandsContainer.parentElement.classList.toggle("hidden", !facetBrands?.values);
    }
    renderSuggestions() {
      if (!this.suggestionsContainer)
        return;
      const suggestions = this.searchBox.state.suggestions.slice(0, 3);
      this.suggestionsContainer.innerHTML = suggestions.slice(0, 3).map((suggestion) => {
        return `<li class="hover:bg-light-neutral-20 active:bg-dark-neutral-20">
        <button class="block px-4 py-3 lg:py-2 text-left w-full">${suggestion.highlightedValue}</button>
      </li>`;
      }).join("");
      this.suggestionsContainer.parentElement.classList.toggle("hidden", !suggestions.length);
    }
    async renderProducts() {
      const products = this.search.state.products.slice(0, 4);
      if (!products.length) {
        await delay(500);
        this.classList.remove("is-products-show");
        return;
      }
      const itemsCountElm = this.productsContainer.querySelector(".js-items-count");
      const resultsContainer = this.productsContainer.querySelector("ul");
      const { currentCollectionHandle } = theme.routes;
      const parentCollectionHandle = new URLSearchParams(window.location.search).get("pc");
      itemsCountElm && (itemsCountElm.textContent = this.pagination.state.totalEntries);
      resultsContainer.innerHTML = await this.fetchProductCards(products);
      resultsContainer.querySelectorAll("a").forEach((a) => {
        const newURL = new URL(a.href);
        if (parentCollectionHandle) {
          newURL.searchParams.set("pc", parentCollectionHandle);
        }
        if (currentCollectionHandle && currentCollectionHandle !== parentCollectionHandle) {
          newURL.searchParams.set("sc", currentCollectionHandle);
        }
        a.href = newURL.toString();
      });
      this.classList.add("is-products-show");
      this.setAttribute("data-count", resultsContainer.childElementCount);
    }
    setState(state) {
      switch (state) {
        case "show-results":
          this.classList.remove("is-recent", "is-loading");
          this.classList.add("is-open", "is-results");
          break;
        case "show-recent":
          this.classList.remove("is-results", "is-loading");
          this.classList.add("is-open", "is-recent");
          break;
        case "close":
          this.classList.remove("is-open");
          break;
        case "loading":
          this.classList.remove("is-results", "is-recent", "is-empty");
          this.classList.add("is-open", "is-loading");
          break;
        case "empty":
          this.classList.remove("is-recent", "is-loading");
          this.classList.add("is-results", "is-empty");
          break;
      }
    }
    fetchProductCards(products) {
      return fetchSortedProductCards(products);
    }
    initViewAllButton() {
      const button = this.querySelector(".js-view-all-button");
      if (!button)
        return;
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const query = this.input.value.trim();
        if (!query)
          return;
        this.submitSearch(query);
      });
    }
    updateViewAllButton() {
      const button = this.querySelector(".js-view-all-button");
      if (!button)
        return;
      const queryLabel = this.querySelector(".js-view-all-query");
      queryLabel.textContent = this.input.value;
      button.href = `${window.location.origin}${theme.routes.searchUrl}?q=${encodeURIComponent(this.input.value)}`;
    }
    initCloseEvents() {
      const closeButtons = this.querySelectorAll(".js-close-button");
      closeButtons.forEach((button) => button.addEventListener("click", () => this.setState("close")));
      document.addEventListener("click", (event) => {
        if (!this.contains(event.target) && this.classList.contains("is-open")) {
          this.setState("close");
        }
      });
    }
    checkEmpty() {
      if (this.firstRender) {
        this.firstRender = false;
        return;
      }
      const count = [this.search.state.products.length, this.searchBox.state.suggestions.length].reduce(
        (acc, curr) => acc + curr,
        0
      );
      count ? this.setState("show-results") : this.setState("empty");
    }
  };
  var debounce = (func, delay2) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(void 0, args);
      }, delay2);
    };
  };
  window.customElements.define("coveo-search-form", CoveoSearchForm);
  window.customElements.define("coveo-recent-queries", CoveoRecentQueries);
})();
